<mat-card>
    @if (docuSignLoadingAction$ | async) {
      <div id="spinner-container" class="loading-container">
        <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
        <div class="loading-text">Loading...</div>
      </div>
    }

    @if (isVoidingAgreement$ | async) {
      <div id="spinner-container" class="loading-container">
        <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
        <div class="loading-text">Voiding agreement...</div>
      </div>
    }

    <mat-card-content>
      <h1><b>Agreement</b></h1>
      <div id="note">
        <p>Note: The agreement must be signed to complete the registration process. For any query regarding agreement contact <a href="mailto:{{ agreementEmail$ | async}}">{{ agreementEmail$ | async}}</a></p>
      </div>

      <div id="top">
        <form [formGroup]="agreementForm"
              [connectForm]="form$ | async">
          <mat-form-field>
            <mat-label>Year</mat-label>
            <mat-select formControlName="year">
                  @for (year of getYears(); track year;) {
                    <mat-option [value]="year">{{ year }}</mat-option>
                  }
              </mat-select>
          </mat-form-field>
        </form>

        <div class="action-buttons">
          <button mat-fab extended (click)="refreshPage()" class="warn" id="refresh">
            <mat-icon>sync</mat-icon>
            Refresh
          </button>

          <button mat-fab extended (click)="createEnvelope()" class="warn" id="createEnvelope"
            [disabled]="(creatingDocument$ | async) || (mustVoidFirst$ | async)"
            [matTooltip]="(mustVoidFirst$ | async) ? 'Void the pending agreement before creating a new one.' : ''">
            <mat-icon>add</mat-icon>
            Create Agreement
          </button>

          <button mat-fab extended (click)="sendViaEmail()" id="sendViaEmail"
            [disabled]="(creatingDocument$ | async) || (mustVoidFirst$ | async)"
            [matTooltip]="(mustVoidFirst$ | async) ? 'Void the pending agreement before creating a new one.' : ''">
            <mat-icon>email</mat-icon>
            Send via Email
          </button>
        </div>
      </div>

      @if (mustVoidFirst$ | async) {
        <div class="warning-inline">
          <mat-icon>warning</mat-icon>
          <span>Please void the pending agreement before creating a new one.</span>
        </div>
      }
      @if ((hasExistingAgreement$ | async) && !(mustVoidFirst$ | async)) {
        <div class="info-inline">
          <mat-icon>info</mat-icon>
          <span>You have an existing agreement. Creating a new agreement will permanently delete the existing one.</span>
        </div>
      }

      @if ((data$ | async)?.length ?? 0 > 0) {
        <ag-grid-angular
          style="width: 100%; height: 70vh"
          [columnDefs]="colDefs"
          [rowData]="data$ | async"
          [loading]="tableLoading$ | async"
          [defaultColDef]="defaultColDef"
          [theme]="standardTheme"
          [rowHeight]="52"
        />
      } @else {
        <div id="no-agreements">
          <p><i>No agreements found for the selected year.</i></p>
        </div>
      }

      <div class="documents-section">
        <div class="documents-header">
          <h2><b>Uploaded Documents</b></h2>
          <button mat-fab extended (click)="openUploadModal()" class="warn" id="upload-document">
            <mat-icon>upload_file</mat-icon>
            Upload Document
          </button>
        </div>

        <ag-grid-angular
          style="width: 100%; height: 40vh"
          [columnDefs]="documentColDefs"
          [rowData]="uploadedDocuments$ | async"
          [loading]="documentsLoading$ | async"
          [defaultColDef]="defaultColDef"
          [theme]="standardTheme"
        />
      </div>

  </mat-card-content>
</mat-card>
